module.exports = __webpack_public_path__ + "img/wz-7-4-1.77b968bd.jpg";